import { formatDate } from "date-fns";
import type { PortfolioDocumentListItemDTO } from "web_myplann/Infrastructure/Api/Api";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";

export const pinnedDocumentSubtitle = (
	document: PortfolioDocumentListItemDTO,
): string =>
	[
		document.createdAt
			? formatDate(new Date(document.createdAt), DateFormat.Display)
			: null,
		document.folder,
	]
		.filter(Boolean)
		.join(" · ");
